module.exports = __webpack_public_path__ + "static/media/faq-bg.6dadfb0b.jpg";